import { render, staticRenderFns } from "./VeracruzExamesIntraOperatorios.vue?vue&type=template&id=48a3bef3&scoped=true"
import script from "./VeracruzExamesIntraOperatorios.vue?vue&type=script&lang=ts"
export * from "./VeracruzExamesIntraOperatorios.vue?vue&type=script&lang=ts"
import style0 from "./VeracruzExamesIntraOperatorios.vue?vue&type=style&index=0&id=48a3bef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3bef3",
  null
  
)

export default component.exports